import { sendPost } from '@utils/request';
// 判断首页有没有健身
export function nav(data) {
  const url = '/health/homepage';
  return sendPost({ url, data, baseURL: false, applicationType:false });
}
// 获取频道数据 新接口
export function getExistChannelCategory(data) {
  const url = '/api/health/sales/channelCategory/getExistChannelCategory';
  return sendPost({ url, data, baseURL: true});
}

// 品牌详情数据
export function getRecommendMould(data) {
  const url = '/api/healthMould/getRecommendMould';
  return sendPost({ url, data });
}

